import { on as onEvent } from "common/utils/ui/event";
import { storage } from "common/utils/storage";
import { EventBus, Events } from "jiffy-store";
import WholesalePricingToast from "components/jiffy/wholesale-pricing-toast/wholesale-pricing-toast";

const STORAGE_KEY = "user-box-saved-projects-notification-dismissed";
const WHOLESALE_TOAST_ID = "js-wholesale-pricing-toast";

// Getters

const $getNotifications = () => document.querySelectorAll(".user-box-saved-projects-notification");

const $getWholesaleToast = () => document.getElementById(WHOLESALE_TOAST_ID);

const getIsDismissed = () => storage.get(STORAGE_KEY) === true;

const shouldWaitForWholesaleToast = () => {
  const $toast = $getWholesaleToast();
  return $toast && WholesalePricingToast.shouldShow();
};

// Setters

const setNotificationVisibility = ($notifications, isVisible) => {
  $notifications.forEach($notification => {
    $notification.classList.toggle("hidden", !isVisible);
  });
};

const setDismissedState = isDismissed => {
  storage.set(STORAGE_KEY, isDismissed);
};

// Actions

const showNotifications = () => {
  const $notifications = $getNotifications();
  setNotificationVisibility($notifications, true);
};

const dismissNotification = () => {
  const $notifications = $getNotifications();
  setNotificationVisibility($notifications, false);
  setDismissedState(true);
};

const handleNotificationClick = event => {
  event.stopPropagation();
  event.preventDefault();
};

const handleCloseClick = event => {
  event.stopPropagation();
  event.preventDefault();
  dismissNotification();
};

// Inits

const initNotificationHandles = () => {
  onEvent("click", ".user-box-saved-projects-notification", handleNotificationClick);
  onEvent("click", ".js-user-box-notification-close", handleCloseClick);
};

const waitForWholesaleToastDismissal = () => {
  const handleToastDismissal = () => {
    showNotifications();
    initNotificationHandles();
  };

  const handleDismissedEvent = () => {
    EventBus.removeEventListener(Events.WHOLESALE_PRICING_TOAST_DISMISSED, handleDismissedEvent);
    handleToastDismissal();
  };

  EventBus.on(Events.WHOLESALE_PRICING_TOAST_DISMISSED, handleDismissedEvent);
};

const initUserBoxNotification = () => {
  if (getIsDismissed()) {
    return;
  }

  if (shouldWaitForWholesaleToast()) {
    waitForWholesaleToastDismissal();
  } else {
    showNotifications();
    initNotificationHandles();
  }
};

export default initUserBoxNotification;
